var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 22.1714V24.0114C41.9975 28.3243 40.601 32.5208 38.0187 35.9751C35.4363 39.4294 31.8066 41.9564 27.6707 43.1792C23.5349 44.4021 19.1145 44.2552 15.0689 42.7606C11.0234 41.266 7.56931 38.5036 5.22192 34.8856C2.87453 31.2675 1.75958 26.9876 2.04335 22.6841C2.32712 18.3806 3.99441 14.2841 6.79656 11.0056C9.59871 7.72709 13.3856 5.44221 17.5924 4.49174C21.7992 3.54127 26.2005 3.97612 30.14 5.73145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3798 7.95949C39.758 7.68337 40.1869 7.48444 40.6421 7.37408C41.0972 7.26372 41.5696 7.24408 42.0323 7.31629C42.495 7.3885 42.939 7.55114 43.3388 7.79492C43.7387 8.0387 44.0866 8.35885 44.3627 8.7371C44.6389 9.11534 44.8378 9.54427 44.9481 9.99939C45.0585 10.4545 45.0781 10.9269 45.0059 11.3896C44.9337 11.8523 44.7711 12.2963 44.5273 12.6961C44.2835 13.096 43.9634 13.4439 43.5851 13.7201L24.1432 27.9131L17.0001 28.7125L19.9379 22.1526L39.3798 7.95949Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/Edit Circle.292196c3119f7b08e176ea9e5bb9b38e.svg";
export { ForwardRef as ReactComponent };